export function isEmptyValue(v: unknown): boolean {
  if (v == null) return true;
  if (typeof v === 'boolean') return false; // keep false as a valid value for hazardous filter to work
  if (Array.isArray(v)) return v.length === 0;
  if (typeof v === 'string') return v.length === 0;
  return false;
}
